<div class="owner">
  <div class="owner-content"><ng-content select="[owner]"></ng-content></div>
  <mat-icon class="menu" *ngIf="menu">more_vert</mat-icon>
</div>

<div class="title" [routerLink]="route">
  <ng-content select="[title]"></ng-content>
</div>

<div class="content">
  <div class="dynamic-content" #content>
    <ng-content></ng-content>
  </div>
</div>
